// extracted by mini-css-extract-plugin
export default {"mainContainer":"Transactions_mainContainer__tpiTX"};